import React, { useContext } from 'react';
import C from '@ordermentum/ui-constants';
import classNames from 'classnames';
import { Theme, ThemeContext } from '../../utilities/theme';
import illustrationFiles, { IllustrationNames } from './files';

export type IllustrationProps = {
  name: IllustrationNames;
  accessibleTitle?: string;
  className?: string;
  fileExtension?: FileExtensions;
};

export type FileExtensions = 'png' | 'svg';

const getImageUrl = (
  name: string,
  theme: Theme,
  fileExtension: FileExtensions
) => {
  const suffix = theme === 'futuro-dark' ? 'dark' : 'light';
  return `${C.IMAGE_URL}/${illustrationFiles[name]}-${suffix}.${fileExtension}`;
};

/**
 * Illustrations as described in the CORE design system
 *
 * @see https://www.figma.com/file/zYke5qihweC8yQSpXpcRO2/%F0%9F%93%9000-OM-CORE-Library?node-id=730%3A3207
 */
export const Illustration = ({
  name,
  accessibleTitle,
  className,
  fileExtension = 'png',
}: IllustrationProps) => {
  const theme = useContext(ThemeContext);

  return (
    <img
      className={classNames(className || 'inline w-44 h-44')}
      src={getImageUrl(name, theme, fileExtension)}
      alt={accessibleTitle}
      title={accessibleTitle}
    />
  );
};

export const illustrationNames = Object.keys(illustrationFiles);

export default Illustration;
